// ssmlSlice.ts
import { createGenericSlice } from './generic.slice'
import { RootState } from '@store/store'
export interface SsmlModel {
  id?: string
  ssmlContent: string
  updatedAt?: string
  updatedBy?: string
}

// Create the generic slice for the SsmlModel entity
const {
  slice: ssmlSlice,
  thunks: ssmlThunks,
  adapter: ssmlAdapter,
} = createGenericSlice<SsmlModel>(
  'Ssml',
  'ssml',
  {} // You can define extra initial state properties if needed
)

// Export the entity adapter's generated selectors
export const {
  selectById: selectSsmlById,
  // ... other selectors
} = ssmlAdapter.getSelectors<RootState>((state: RootState) => state.ssmls)

// Export the generated async thunks
export const { fetchById: fetchSsmlById, update: updateSsml } = ssmlThunks

export default ssmlSlice.reducer
